/**
 * EDIT tab — host event edit handoff §"Wizard (EDIT tab and create)". The builder
 * (EventCreatePage, `inline`) draws the whole wizard here: the EDIT EVENT kicker + STEP n / 5
 * note, the five step pills, the step cards, the review's HEADS UP note and the sticky
 * footer (← BACK · NEXT → · VIEW PUBLIC PAGE ↗ · SAVE CHANGES). This component is the gate
 * around it: EDITING IS CLOSED when the viewer can't edit or the event is over, and the
 * GATHERING EXTRAS card for a gathering pass. The parent owns the step (`?step=` deep link)
 * and answers a save with the toast.
 */
import React from 'react';
import EventCreatePage from '../../pages/EventCreatePage';
import GatheringExtrasPanel from '../GatheringExtrasPanel';
import { Card } from './kit';
import { EDITABLE_STATUSES } from './hostOpsModel';

export default function HostEdit({ event, eventId, mobile = false, canEdit, paidCount = 0, gatheringInfo = null, onSaved, onInvalid, onViewPublic, step, onStepChange }) {
  const editable = canEdit && EDITABLE_STATUSES.includes(event?.status);
  const gathering = event?.isGatheringPass && event?.gatheringId
    ? <GatheringExtrasPanel passEvent={event} gatheringId={event.gatheringId} giveTakeEnabled={gatheringInfo?.giveTakeEnabled} />
    : null;

  if (!editable) {
    return (
      <div className="hev-col" data-testid="edit-tab">
        <Card gap="8" testId="edit-closed">
          <span className="hev-sec-title">EDITING IS CLOSED</span>
          <span className="hev-sec-sub">
            {!canEdit
              ? 'Only the host and co-hosts with edit permission can change this event.'
              : 'This event has ended or been canceled. Duplicate it from HOST ACTIONS to run it again.'}
          </span>
        </Card>
        {gathering}
      </div>
    );
  }

  return (
    <div className="hev-col" data-testid="edit-tab">
      <EventCreatePage
        inline
        eventId={eventId}
        step={step}
        onStepChange={onStepChange}
        onSaved={onSaved}
        onInvalid={onInvalid}
        onViewPublic={onViewPublic}
        paidCountProp={paidCount}
        afterSteps={gathering}
        mobile={mobile}
      />
    </div>
  );
}
